module.exports = __webpack_public_path__ + "static/media/showerRect270.b5b9652e.png";